<p *ngIf="!isUnavaiable">
  Authenticating...
 </p>
 <router-outlet *ngIf="isUnavaiable"></router-outlet>
